// Shared Reg M colours (PreClear and History).
export const GLAZER_GREEN = "#006842";
// Darker amber (Tailwind amber 700): at least 4.5:1 as text on white and with white text on it.
export const AMBER_TEXT = "#b45309";

// Filled amber chip (flagged, pending, a true marker) with readable white text.
export const amberChipSx = { bgcolor: AMBER_TEXT, color: "#fff" };
